import ValueWithDependencies from './ValueWithDependencies.jsx';

const replaceValuesWithDependencies = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map((item) => replaceValuesWithDependencies(item));
  }

  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      // Check if this object has the structure {value: ..., indices: [...]}
      if ('value' in value && 'indices' in value) {
        const { value: actualValue, indices } = value;
        if (Array.isArray(indices) && indices.length > 0 && typeof actualValue === 'string') {
          result[key] = <ValueWithDependencies value={actualValue} dependencies={indices} />;
        } else {
          result[key] = actualValue;
        }
      } else if ('value' in value && !('indices' in value)) {
        // Object has only 'value' property, extract it
        result[key] = value.value;
      } else {
        // Regular object, recurse into it
        const processedValue = replaceValuesWithDependencies(value);
        // Only include non-empty objects
        if (Object.keys(processedValue).length > 0) {
          result[key] = processedValue;
        }
      }
    } else if (Array.isArray(value)) {
      // Handle arrays within objects
      result[key] = value.map((item) => replaceValuesWithDependencies(item));
    } else {
      // Primitive value, keep as is
      result[key] = value;
    }
  }

  return result;
};

export default replaceValuesWithDependencies;
